import React from "react";
import { Button, IconButton } from "@material-ui/core";
import PlusIcon from "@material-ui/icons/Add";
import moment from "moment";
import WorkorderEdit from "../components/workorders/workorderedit";
import WorkorderService from "../services/workorders";


import WorkorderItemEdit from "../components/workorderitems/workorderitemedit";
import WorkorderItemService from "../services/workorderitems";
import UserService from "../services/users";
import ProjectService from "../services/projects";
import SearchProject from "../components/projects/search";

import Signing from "../components/workorders/signing";

import ActionButton from '../components/layout/actionButtons';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import SendIcon from '@material-ui/icons/Send'

import ChangeStatus from '../components/workorders/changeStatus';
import formattingStyle from "../styles/formatting";


class Workorder extends React.Component {
  constructor(props) {
    super(props);
    this.state = { order: {}, orderitems: [], projects: [], addWorkDate: new Date(), expanded: null, showChangeStatus: false, showProjectSearch: false, showSigning: false, user: {}, holidays: [], babies: [], docters: [] };
  }
  compareNr(a, b) {
    if (a.projectnumber > b.projectnumber)
      return -1;
    if (a.projectnumber < b.projectnumber)
      return 1;
    return 0;
  }
  componentDidMount() {
    if (!this.props.match.params.id) {
      UserService.initLogin().then(
        () => {
             const currentUser = UserService.currentUser()
               this.setState({ user: currentUser });
        },
        (error) => { }
      )
      this.props.history.push('/workorders');
    } else {
      WorkorderService.get(this.props.match.params.id).then(
        (order) => {
          UserService.get(order.user).then(user => {
            this.setState({ user: user });
          }, err => { })

          this.setState({ order });
          this.getOrderItems(order);
          this.setState({
            expanded: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toString(),
          });
          //get approved holidays
          WorkorderItemService.getHolidayForUser(order.user).then(
            result => {
              this.setState({ holidays: result });
            },
            error => {
              console.log("error", error);
            }
          );
          WorkorderItemService.getBabiesForUser(order.user).then(
            result => {
              this.setState({ babies: result });
            },
            error => {
              console.log("error", error);
            }
          );
          WorkorderItemService.getDoctersForUser(order.user).then(
            result => {
              this.setState({ docters: result });
            },
            error => {
              console.log("error", error);
            }
          );
        },
        (err) => {
          this.props.handleMessage({ title: "Kan de gegevens niet ophalen" });
          this.props.history.push('/workorders')
        }
      )
      ProjectService.get().then(
        (projects) => {
          this.setState({ projects: projects.sort(this.compareNr) });
        },
        (error) => { }
      )
    }

    //get and update currentuser
    //  const currentUser = UserService.currentUser()
    //  this.setState({ user: currentUser });

    UserService.initLogin().then(
      () => {
        //   const currentUser = UserService.currentUser()
        //     this.setState({ user: currentUser });
      },
      (error) => { }
    )
  }

  handleSign = (ev) => {
    ev.preventDefault();
    if (document.documentElement) { document.documentElement.scrollTop = 0 }
    this.setState({ showSigning: true });

  }

  getOrderItems = (order) => {
    WorkorderItemService.getByOrderGUID(order.guid, order.user).then(
      (orderitems) => {
        this.setState({ orderitems });
        let sendButton = '';
        let signButton = '';
        if (this.state.order.status === 0 || this.state.order.status === 2) {
          sendButton = <Button
            variant="contained"
            onClick={this.sendOrder}
            color="primary"
          > Verstuur  <SendIcon style={{ marginLeft: '10px' }} /></Button>;

          /*signButton = <Button
          variant="contained"
          onClick={this.handleSign}
          color="primary"
        > Ondertekenen</Button>;
       */
        }

        let deleteButton = '';
        if (this.props.isAdmin || this.state.order.status !== 3) { deleteButton = <IconButton onClick={() => { window.confirm("Weet u zeker dat u deze gehele werkbon wilt verwijderen?") && this.handleDelete(this.state.order) }}><DeleteIcon style={{ color: 'FFF' }} /></IconButton> }

        let changeStatusButton = '';
        if ((this.state.order.status === 1 || this.state.order.status === 2 || this.state.order.status === 3) && this.props.isAdmin) {
          changeStatusButton = <Button
            variant="contained"
            onClick={this.toggleChangeStatus}
            color="primary"
          > Aanpassen status</Button>;
        }
        this.props.handleMenu(
          {
            title: 'Werkbon',
            showBackButton: true,
            handleActions: <ActionButton {...this.props} itemleft={<React.Fragment>{deleteButton}{sendButton}{signButton}{changeStatusButton}</React.Fragment>}></ActionButton>
          })

      },
      (err) => {
        this.props.handleMessage({ title: "Kan de gegevens niet ophalen" });
        this.props.history.push('/workorders')
      }
    )
  }

  sendOrder = () => {
    if (WorkorderService.checkComplete(this.state.order, this.state.orderitems)) {
      let order = Object.assign({}, this.state.order);
      order.status = 1;
      this.handleSaveBeforeSending(order, this.state.orderitems).then((result) => {
        this.setState({ order }, () => {
          WorkorderService.save(order, true)
            .then(
              (result) => {
                this.props.handleMessage({ title: "De werkbon is verstuurd" });
                this.props.history.push('/workorders')
              },
              (err) => {

              })
        });
      }, (err) => {
      })
    } else {
      this.props.handleMessage({ title: "De werkbon kan nog niet worden verstuurd, controleer of alle locaties zijn ingevoerd." });
    }
  }
  updateStatusOrderItems = (order) => {
    let orderitems = Object.assign([], this.state.orderitems);
    for (let i = 0; i < orderitems.length; i++) {
      orderitems[i].status = order.status;
    }
    this.setState({ orderitems });
    return orderitems;
  }
  handleSaveBeforeSending = (order, orderitems) => {
    return new Promise((resolve, reject) => {
      WorkorderService.save(order).then(
        result => {
          let orderitems = this.updateStatusOrderItems(order);
          WorkorderItemService.saveItems(orderitems).then(
            result => {
              resolve(result);
            },
            error => {
              this.props.handleMessage({ title: "Het opslaan is mislukt, controleer uw internetverbinding" });
              reject();
            }
          )
        },
        error => {
          this.props.handleMessage({ title: "Het opslaan is mislukt, controleer uw internetverbinding" });
          reject();
        }
      );
    })

  }

  updateOrder = (order) => {
    this.setState({ order });
  }

  toManyHolidayDockerBaby = (orderItems, orderItem) => {
    let requestMinutes = 0;
    let totalMinutes = 0;
    let givenMinutes = 0;
    //dokter
    if (orderItem.project && orderItem.project.isdocter) {
      let items = orderItems.filter(item => { return (item.project && item.project.isdocter) });
      for (let i = 0; i < items.length; i++) {
        if (items[i].guid === orderItem.guid) {
          requestMinutes += orderItem.minutes;
        } else {
          requestMinutes += items[i].minutes;
        }
      }
      const hours = this.state.user.docterhours.find(item => { return (item.year === moment(orderItem.date).year()) });
      if (hours) {
        totalMinutes = parseInt(hours.total) * 60;
      }
      let doctersThisYear = this.state.docters.filter(item => { return (moment(item.date).year() === moment(orderItem.date).year()) });
      for (let i = 0; i < doctersThisYear.length; i++) {
        givenMinutes += doctersThisYear.minutes || 0;
      }
      if ((totalMinutes - givenMinutes) < requestMinutes) {
        this.props.handleMessage({ title: "Er zijn niet genoeg dokters uren beschikbaar." });
        return true;
      }
    }
    //baby
    if (orderItem.project && orderItem.project.isbaby) {
      let items = orderItems.filter(item => { return (item.project && item.project.isbaby) });
      for (let i = 0; i < items.length; i++) {
        if (items[i].guid === orderItem.guid) {
          requestMinutes += orderItem.minutes;
        } else {
          requestMinutes += items[i].minutes;
        }
      }
      const hours = this.state.user.babyhours.find(item => { return (item.year === moment(orderItem.date).year()) });
      if (hours) {
        totalMinutes = parseInt(hours.total) * 60;
      }
      let babiesThisYear = this.state.babies.filter(item => { return (moment(item.date).year() === moment(orderItem.date).year()) });
      for (let i = 0; i <babiesThisYear.length; i++) {
        givenMinutes += babiesThisYear[i].minutes || 0;
      }
      if ((totalMinutes - givenMinutes) < requestMinutes) {
        this.props.handleMessage({ title: "Er zijn niet genoeg ouderschapsverlof uren beschikbaar." });
        return true;
      }
    }
    //holiday
    if (orderItem.project && orderItem.project.isholiday) {
      let items = orderItems.filter(item => { return (item.project && item.project.isholiday) });
      for (let i = 0; i < items.length; i++) {
        if (items[i].guid === orderItem.guid) {
          requestMinutes += orderItem.minutes;
        } else {
          requestMinutes += items[i].minutes;
        }
      }
      console.log('Totaal gewenste minuten ', requestMinutes, items);
      const hours = this.state.user.holydayhours.find(item => { return (item.year === moment(orderItem.date).year()) });
      if (hours) {
        totalMinutes = parseInt(hours.total) * 60;
        console.log('Totaal vakantie minuten ', totalMinutes, this.state.user.holydayhours);
      }
      let holidaysThisYear = this.state.holidays.filter(item => { return (moment(item.date).year() === moment(orderItem.date).year()) });
      for (let i = 0; i < holidaysThisYear.length; i++) {
        givenMinutes += holidaysThisYear.minutes || 0;
      }
      console.log('Totaal gegeven vakantie minuten ', givenMinutes, holidaysThisYear);
      if ((totalMinutes - givenMinutes) < requestMinutes) {
        this.props.handleMessage({ title: "Er zijn niet genoeg vakantie uren beschikbaar." });
        return true;
      }
    }
    return false;
  }

  updateOrderItem = (orderItem) => {
    this.setState(orderitems => {
      const list = this.state.orderitems.map((item) => {
        if (item.guid === orderItem.guid) {
         // if (this.toManyHolidayDockerBaby(this.state.orderitems, orderItem) == false) {
            item = orderItem;
        //  }
        }
        return item;
      });

      return { orderitems: list };
    }, () => {
    });
  }

  handleSaveOrder = (order) => {
    return new Promise((resolve, reject) => {
      WorkorderService.save(order, true).then(
        result => {
          resolve(result);
          //update status orderitems
          if (this.state.orderitems) {
            let orderitems = this.state.orderitems;
            for (let i = 0; i < orderitems.length; i++) {
              orderitems[i].status = order.status;
            }
            WorkorderItemService.saveItems(orderitems, true);
            this.setState(orderitems);
          }

        },
        error => {
          reject(error);
        }
      );
    })

  }

  handleSaveOrderItem = (item) => {
    return new Promise((resolve, reject) => {
      WorkorderItemService.save(item, true).then(
        result => {
          resolve(result);
        },
        error => {
          // this.props.handleMessage({ title: "Het opslaan is mislukt" });
          reject(error);
        }
      )
    })
  }



  handleDelete = (order) => {
    WorkorderService.delete(order).then(
      result => {
        WorkorderItemService.deleteItems(this.orderitems)
          .then((result) => {
            this.props.history.push('/workorders');
          }, (error) => {
            this.props.history.push('/workorders');
          })

      },
      error => {
        this.props.handleMessage({ title: "Fout bij het verwijderen." });
      }
    );
  }

  handleDeleteOrderItem = (orderitem) => {

    try {
      WorkorderItemService.delete(orderitem).then(
        result => {
          this.getOrderItems(this.state.order);
        },
        error => {
          this.props.handleMessage({ title: "Fout bij het verwijderen." });
          this.getOrderItems(this.state.order);
        }
      );
    } catch (ex) {
      this.getOrderItems(this.state.order);
    }

  }


  newOrderItem = (project) => {
    this.setState({ showProjectSearch: false });
    let userID = this.state.order.user;
    if (typeof this.state.order.user !== 'string') {
      userID = this.state.order.user._id;
    }
    WorkorderItemService.createNewOrderItem(userID, this.state.order.guid, project, this.state.addWorkDate)
      .then((orderItem) => {
        this.setState(state => ({
          orderitems: [...state.orderitems, orderItem]
        }));
        //show tab
        this.setState({
          expanded: new Date(new Date(orderItem.date).getFullYear(), new Date(orderItem.date).getMonth(), new Date(orderItem.date).getDate()).toString(),
        });
        window.scrollTo(0, document.body.scrollHeight);
      }, error => {
        this.props.handleMessage({ title: "Het aanmaken is mislukt." });
      })
  }

  toggleChangeStatus = () => {
    this.setState({ showChangeStatus: !this.state.showChangeStatus });
  }

  changeStatus = (status, message) => {
    this.setState({ showChangeStatus: !this.state.showChangeStatus });

    let order = Object.assign({}, this.state.order);
    order.status = status;
    order.remarks = message;
    this.setState({ order: order }, () => {
      this.handleSaveOrder(order);
    });
  }

  handleChangePanel = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  saveSignings = (orderItems) => {
    orderItems.forEach(item => {
      this.updateOrderItem(item);
      this.handleSaveOrderItem(item).then(
        (result) => {
          this.getOrderItems(this.state.order);
        }, (error) => { })
    });

  }

  render() {
    const { expanded } = this.state;
    let readonly = (WorkorderService.isStatusReadOnly(this.state.order.status));
    if (this.props.isAdmin) {//&& this.state.order.status === 1) {
      readonly = false;
    }
    //get orderitems
    let orderItems = '';
    if (this.state.orderitems && this.state.order._id) {
      const uniqueDays = WorkorderItemService.getUniqueDays(this.state.orderitems, this.state.order);
      orderItems = uniqueDays.map((item) => {
        return <ExpansionPanel expanded={expanded === item.toString()} onChange={this.handleChangePanel(item.toString())} key={item}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: '#e2e2e2' }}>
            <div style={formattingStyle.header} >{moment(item).format('dddd DD MMMM')} - {WorkorderItemService.getTotals(this.state.orderitems, item)}</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ display: 'block' }}>
            {this.state.orderitems.filter((orderitem => { return (moment(orderitem.date).format('YYYY MM DD') === moment(item).format('YYYY MM DD')) })).map((orderitem) => {
              if (!orderitem.date) { orderitem.date = new Date() }
              if (!orderitem.minutes) { orderitem.minutes = 0 }
              return <WorkorderItemEdit user={this.state.user} holidays={this.state.holidays} babies={this.state.babies} docters={this.state.docters} orderitem={orderitem} update={this.updateOrderItem} save={this.handleSaveOrderItem} delete={this.handleDeleteOrderItem} readonly={((orderitem.signature !== undefined && orderitem.signature !== '' && orderitem.signature !== 0 && !this.props.isAdmin) || readonly)} key={orderitem.guid} projects={this.state.projects}  {...this.props} ></WorkorderItemEdit>
            })}
            {
              !readonly
              && <Button variant="contained" color="primary" onClick={() => { this.setState({ addWorkDate: moment(item).toDate() }); this.setState({ showProjectSearch: true }) }} style={{ width: '100%' }}><PlusIcon />Werk toevoegen bij {moment(item).format('dddd DD MMMM')} </Button>

            }
          </ExpansionPanelDetails>
        </ExpansionPanel>
      })
    }
    return (
      <React.Fragment>
        {this.state.showSigning && <Signing handleClose={() => { this.setState({ showSigning: false }) }} handleSave={this.saveSignings} orderItems={this.state.orderitems}></Signing>}
        <div className="padding">
          {this.state.showProjectSearch && <SearchProject save={this.newOrderItem} onClose={() => { this.setState({ showProjectSearch: false }) }} projects={this.state.projects.filter(item => { return (item.inactive === false || item.inactive === undefined) })} />}
          {this.state.showChangeStatus && <ChangeStatus onClose={this.toggleChangeStatus} onChange={this.changeStatus} />}
          <WorkorderEdit update={this.updateOrder} order={this.state.order} orderitems={this.state.orderitems} save={this.handleSaveOrder} readonly={readonly} {...this.props} />

          <br style={{ clear: 'both' }} />
          {orderItems}
          {
            !readonly
            && <Button variant="contained" color="primary" onClick={() => this.setState({ showProjectSearch: true })} style={{ width: '100%' }}><PlusIcon />Werk toevoegen</Button>

          }
          <br style={{ clear: 'both' }} /><br style={{ clear: 'both' }} />
          {(this.state.order.status === 0 || this.state.order.status === 2)
            && <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={this.handleSign}  > Plaats handtekening</Button>
          }
          <br style={{ clear: 'both' }} /><br style={{ clear: 'both' }} />
        </div>
      </React.Fragment>
    );
  }
}
export default Workorder;
